import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, y = 28, className = '' }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.65, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, as: Tag = 'h1', className = '', lineClassName = '', baseDelay = 0.15, testid }) {
  const reduce = useReducedMotion();
  return (
    <Tag className={className} data-testid={testid}>
      {lines.map((line, i) => {
        const text = typeof line === 'string' ? line : line.text;
        const accent = typeof line === 'object' && line !== null && line.accent;
        return (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className={`block ${accent ? 'text-lime' : ''} ${lineClassName}`}
              initial={reduce ? false : { y: '110%' }}
              animate={reduce ? undefined : { y: 0 }}
              transition={{ duration: 0.7, delay: baseDelay + i * 0.11, ease: EASE }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}
